import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import './SupportCard.css';

function SupportCard({ moduleId, support }) {
  return (
    <>
      {support &&
        support.map((d) => {
          const { id, status, title, description, attachments, category, ticket_id, priority, reply_count } = d;
          return (
            <div className="ticket-container">
              <div className="ticket-card" key={id}>
                <div className="ticket-header">
                  <span className="ticket-id">#TCK-{ticket_id}</span>
                  <div className="d-flex" style={{ gap: '10px' }}>
                    <span className="status">{category.name}</span>
                    <span
                      className="status"
                      style={
                        status === 'open'
                          ? { background: '#06bc21eb' }
                          : status === 'in_progress'
                          ? { background: '#f5b83b' }
                          : { background: '#f52b2b' }
                      }
                    >
                      {status}
                    </span>
                  </div>
                </div>
                <div className="ticket-title">{title}</div>
                <div className="ticket-body">
                  <ReactMarkdown className="d-markdown" source={description} escapeHtml={false} />
                </div>
                <div className="ticket-footer">
                  <span className="priority">{priority}</span>
                  <div className="assignee">
                    <Link to={{ pathname: `/${moduleId}/support/detail`, search: `?id=${id}`, state: d }}>
                      {reply_count} Replies
                    </Link>
                  </div>
                </div>
                {attachments && attachments.length > 0 && (
                  <div className="attachments">
                    <h6>{attachments.length} Attachments</h6>
                    <div className="attachment-list">
                      {attachments.map((attachment) => (
                        <img src={attachment.file} alt="Attachment" key={attachment.id} className="attachment-image" />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </>
  );
}

export default SupportCard;
